import { reaction } from 'mobx';
import { Observable } from 'rxjs';
export function reaction$(expression, opts) {
    return new Observable((observer) => {
        const dispose = reaction(expression, (current, prev, r) => observer.next({ current, prev, r }), opts);
        return () => dispose();
    });
}
